import { Building2, User } from 'lucide-react'
import logoSecondLane from '@/assets/logoSecondLane.svg'
import signupRightPanel from '@/assets/signupRightPanel.svg'
import type { AccountType } from './SignupTypeSelectionScreen'

interface SignupTypeSelectionScreenDesktopProps {
  onSelect: (accountType: AccountType) => void
}

export const SignupTypeSelectionScreenDesktop = ({ onSelect }: SignupTypeSelectionScreenDesktopProps) => {
  return (
    <div className="relative min-h-screen overflow-hidden bg-white">
      <img
        src={logoSecondLane}
        alt="SecondLane"
        className="absolute left-11 top-6 h-6 w-24"
      />

      <div className="absolute right-0 top-0 hidden h-full w-[832px] lg:block">
        <img
          src={signupRightPanel}
          alt=""
          className="h-full w-full object-cover"
        />
      </div>

      <div className="absolute left-[calc(4.17%+41px)] top-1/2 w-[654px] -translate-y-1/2 px-6 pb-8 pt-7">
        <div className="flex flex-col items-center gap-12">
          <div className="text-center">
            <h1 className="font-plus-jakarta text-[30px] font-medium leading-[40px] tracking-[-0.28px] text-[#2d2923]">
              Choose Your Account Type
            </h1>
            <p className="font-plus-jakarta text-[16px] font-normal leading-[24px] text-[rgba(45,41,35,0.64)] mt-2">
              Select the type of account you'd like to create
            </p>
          </div>

          <div className="w-full grid grid-cols-2 gap-6">
            {/* Individual Account */}
            <button
              type="button"
              onClick={() => onSelect('individual')}
              className="flex flex-col items-center gap-6 p-8 border-2 border-[rgba(45,41,35,0.12)] bg-[rgba(255,255,255,0.72)] hover:border-[rgba(45,41,35,0.32)] hover:bg-[rgba(255,255,255,0.9)] transition-all cursor-pointer"
            >
              <div className="w-16 h-16 rounded-full bg-[rgba(45,41,35,0.08)] flex items-center justify-center">
                <User className="w-8 h-8 text-[#2d2923]" />
              </div>
              <div className="text-center">
                <h3 className="font-plus-jakarta text-[20px] font-medium leading-[28px] text-[#2d2923] mb-2">
                  Individual
                </h3>
                <p className="font-plus-jakarta text-[14px] font-normal leading-[20px] text-[rgba(45,41,35,0.72)]">
                  For personal investment accounts
                </p>
              </div>
            </button>

            {/* Institution Account */}
            <button
              type="button"
              onClick={() => onSelect('institution')}
              className="flex flex-col items-center gap-6 p-8 border-2 border-[rgba(45,41,35,0.12)] bg-[rgba(255,255,255,0.72)] hover:border-[rgba(45,41,35,0.32)] hover:bg-[rgba(255,255,255,0.9)] transition-all cursor-pointer"
            >
              <div className="w-16 h-16 rounded-full bg-[rgba(45,41,35,0.08)] flex items-center justify-center">
                <Building2 className="w-8 h-8 text-[#2d2923]" />
              </div>
              <div className="text-center">
                <h3 className="font-plus-jakarta text-[20px] font-medium leading-[28px] text-[#2d2923] mb-2">
                  Institution
                </h3>
                <p className="font-plus-jakarta text-[14px] font-normal leading-[20px] text-[rgba(45,41,35,0.72)]">
                  For institutional and corporate accounts
                </p>
              </div>
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
